/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリース位置情報(市町村)
 * @export
 * @interface PressReleaseCity
 */
export interface PressReleaseCity {
    /**
     * 位置情報(都道府県)id
     * @type {string}
     * @memberof PressReleaseCity
     */
    prefId?: string;
    /**
     * 位置情報(市町村)id
     * @type {string}
     * @memberof PressReleaseCity
     */
    cityId: string;
    /**
     * 位置情報(市町村)名
     * @type {string}
     * @memberof PressReleaseCity
     */
    cityName: string;
}

export function PressReleaseCityFromJSON(json: any): PressReleaseCity {
    return PressReleaseCityFromJSONTyped(json, false);
}

export function PressReleaseCityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseCity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prefId': !exists(json, 'pref_id') ? undefined : json['pref_id'],
        'cityId': json['city_id'],
        'cityName': json['city_name'],
    };
}

export function PressReleaseCityToJSON(value?: PressReleaseCity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pref_id': value.prefId,
        'city_id': value.cityId,
        'city_name': value.cityName,
    };
}

